import { render, staticRenderFns } from "./IconHappyFace.vue?vue&type=template&id=49911f76&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('49911f76', component.options)
    } else {
      api.rerender('49911f76', component.options)
    }
    module.hot.accept("./IconHappyFace.vue?vue&type=template&id=49911f76&functional=true&", function () {
      api.rerender('49911f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/IconHappyFace.vue"
export default component.exports